import { render, staticRenderFns } from "./search-facets.vue?vue&type=template&id=8caa28de"
import script from "./search-facets.vue?vue&type=script&lang=js"
export * from "./search-facets.vue?vue&type=script&lang=js"
import style0 from "./search-facets.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports